import { ConditionalWrapper } from "@sundae/ui-toolkit";
import { motion } from "framer-motion";
import { FC, HTMLAttributes, PropsWithChildren, ReactNode } from "react";
import { DEFAULT_MOTION_PROPS, fadeInMotion } from "../../constants/motions.constants";
import { useProfileAppContext } from "../../stores";

export interface IPageContentProps extends HTMLAttributes<HTMLDivElement> {
  banner?: ReactNode;
  isWidget?: boolean;
}

const PageContent: FC<PropsWithChildren<IPageContentProps>> = ({
  banner,
  children,
  className,
  isWidget,
}) => {
  if (Boolean(banner) && !isWidget) {
    return (
      <div className="pb-10 pt-48 lg:pt-32">
        <div className="absolute left-0 right-0 top-[5rem] lg:top-[5.5rem]">{banner}</div>
        <div className={className}>{children}</div>
      </div>
    );
  }

  if (Boolean(banner) && isWidget) {
    return (
      <div className="pb-16 pt-52">
        <div className="absolute left-0 right-0 top-[5rem] lg:top-[5.5rem]">{banner}</div>

        <div className={className}>{children}</div>
      </div>
    );
  }

  return <div className={className}>{children}</div>;
};

export const AnimatedPageContent: FC<PropsWithChildren<IPageContentProps>> = ({
  children,
  ...props
}) => {
  const {
    state: { prefersReducedMotion },
  } = useProfileAppContext();

  return (
    <ConditionalWrapper
      condition={!prefersReducedMotion}
      wrapper={(children) => (
        <motion.section {...DEFAULT_MOTION_PROPS} variants={fadeInMotion}>
          {children}
        </motion.section>
      )}
    >
      <PageContent {...props}>{children}</PageContent>
    </ConditionalWrapper>
  );
};

export default AnimatedPageContent;
